import http from './Api';

class SubscriptionPackagesApi {
  static getMeta() {
    return http.get('subscription-packages/meta');
  }

  static list(params) {
    return http.get('subscription-packages', { params });
  }

  static create(data) {
    return http.post('subscription-packages', data);
  }

  static retrySync(id) {
    return http.post(`subscription-packages/${id}/sync`);
  }
}

export default SubscriptionPackagesApi;
